'use strict'

import axios from 'axios'

export default {
  install: (Vue, config) => {
    const apiUrl = config && config.apiUrl ? config.apiUrl : ''
    const docUrl = config && config.docUrl ? config.docUrl : ''
    const authToken = config && config.authToken ? config.authToken : 'Bearer'

    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      return Promise.reject(error)
    })

    Vue.prototype.$http = axios
    Vue.prototype.$apiUrl = apiUrl
    Vue.prototype.$authToken = authToken
    Vue.prototype.$docUrl = docUrl
  }
}



// WEBPACK FOOTER //
// ./src/common/plugins/service.js